import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Container = styled.div`
  flex: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
`
// Stack defines a full-size viewport where items inside of it are
// vertically stacked. Children are typically like:
// <SomeTopBar/>
// <ScrollablePage>...</ScrollablePage>
// <SomeBottombar/>
const Stack = ({ children }) => <Container>{children}</Container>

Stack.propTypes = {
  children: PropTypes.any,
}

export default Stack
